import { Injectable } from '@angular/core';

import { TravelerPaxResponse, LoyaltyResponse } from '@pax/entities/traveler-pax';
import { AirValidationResponse } from '@app/entities/air-validation.response';
import { FrequentFlyerResponse } from '@app/entities/frequent-flyer';

@Injectable()
export class PaxFormLoyaltyService {

  constructor() { }

  public defaultAirline(validator: AirValidationResponse): string {
    return validator && validator.TripOption ? validator.TripOption.ValidatingCarrier : '';
  }

  public defaultAirlineProgram(validator: AirValidationResponse, programs: FrequentFlyerResponse[] = []): string {
    const program = programs.find(item => item.airline_code.includes(this.defaultAirline(validator)));
    return program ? program.program_name : '';
  }

  public getLoyaltyPax(paxTraveler: TravelerPaxResponse): LoyaltyResponse {
    const defaultLoyalty = {} as LoyaltyResponse;
    return paxTraveler && paxTraveler.loyalty ? paxTraveler.loyalty.find(loyalty => loyalty.isSelected) ||
      defaultLoyalty : defaultLoyalty;
  }
}
